import React, { useState } from 'react';
import Backoffice from './backoffice';
import Team from './team';
import Produktionen from './produktionen';
import Formate from './formate';
import Zeiterfassung from './zeiterfassung';
import MeineTasks from './meineTasks';
import MeineProjekte from './meineProjekte';
import DashboardHome from './dashboardHome';
import Workflows from './workflows';
import Masterkalender from './masterkalender';
import Zeitauswertung from './zeitauswertung';
import Abrechnung from './abrechnung';

const Dashboard = ({ user, onLogout }) => {
  const [aktiverBereich, setAktiverBereich] = useState('dashboard');

  const renderContent = () => {
    switch (aktiverBereich) {
      case 'produktionen': return <Produktionen />;
      case 'formatentwicklung': return <Formate />;
      case 'backoffice': return <Backoffice />;
      case 'projekte': return <MeineProjekte user={user} />;
      case 'tasks': return <MeineTasks user={user} />;
      case 'masterkalender': return <Masterkalender user={user} />;
      case 'zeiterfassung': return <Zeiterfassung user={user} />;
      case 'zeitauswertung': return <Zeitauswertung user={user} />;
      case 'workflows': return <Workflows user={user} />;
      case 'abrechnung': return <Abrechnung user={user} />;
      case 'team': return <Team user={user} />;
      default: return <DashboardHome user={user} />;
    }
  };

  return (
    <div style={{
      display: 'flex',
      height: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
      backgroundColor: '#f7f7f5'
    }}>

      {/* Sidebar */}
      <div style={{
        width: '240px',
        backgroundColor: '#ffffff',
        borderRight: '1px solid #efefef',
        display: 'flex',
        flexDirection: 'column',
        padding: '24px 0'
      }}>

        <div style={{
          padding: '0 20px 24px 20px',
          borderBottom: '1px solid #efefef'
        }}>
          <h1 style={{
            fontSize: '16px',
            fontWeight: '700',
            color: '#1a1a1a',
            margin: '0 0 4px 0',
            letterSpacing: '-0.5px'
          }}>
            Studio OS
          </h1>
          <p style={{ fontSize: '11px', color: '#9b9b9b', margin: 0 }}>v1.0.5</p>
        </div>

        <nav style={{ padding: '16px 12px', flex: 1 }}>
          {[
            { label: 'Dashboard', icon: '⌂', key: 'dashboard' },
            { label: 'Produktionen', icon: '▶', key: 'produktionen' },
            { label: 'Formatentwicklung', icon: '◈', key: 'formatentwicklung' },
            { label: 'Backoffice', icon: '◻', key: 'backoffice' },
            { label: 'Projekte', icon: '❏', key: 'projekte' },
            { label: 'Tasks', icon: '✓', key: 'tasks' },
            { label: 'Masterkalender', icon: '▦', key: 'masterkalender' },
            { label: 'Zeiterfassung', icon: '◷', key: 'zeiterfassung' },
            { label: 'Zeitauswertung', icon: '◑', key: 'zeitauswertung' },
            { label: 'Workflows', icon: '⟳', key: 'workflows' },
            { label: 'Abrechnung', icon: '€', key: 'abrechnung' },
            { label: 'Team', icon: '◐', key: 'team' },
          ].map((item) => (
            <div
              key={item.key}
              onClick={() => setAktiverBereich(item.key)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '10px',
                padding: '8px 12px',
                borderRadius: '6px',
                cursor: 'pointer',
                color: aktiverBereich === item.key ? '#1a1a1a' : '#6b6b6b',
                backgroundColor: aktiverBereich === item.key ? '#f0f0ee' : 'transparent',
                fontSize: '13px',
                fontWeight: aktiverBereich === item.key ? '500' : '400',
                marginBottom: '2px'
              }}
            >
              <span style={{
                fontSize: '14px',
                width: '20px',
                textAlign: 'center',
                flexShrink: 0
              }}>{item.icon}</span>
              {item.label}
            </div>
          ))}
        </nav>

        <div style={{
          padding: '16px 20px',
          borderTop: '1px solid #efefef',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          <div>
            <p style={{
              fontSize: '13px',
              fontWeight: '500',
              color: '#1a1a1a',
              margin: '0 0 2px 0'
            }}>
              {user.name}
            </p>
            <p style={{ fontSize: '11px', color: '#9b9b9b', margin: 0 }}>
              {user.role === 'admin' ? 'Administrator' : 'Mitarbeiter'}
            </p>
          </div>
          <button
            onClick={onLogout}
            style={{
              padding: '6px 10px',
              backgroundColor: 'transparent',
              border: '1px solid #e8e8e8',
              borderRadius: '6px',
              fontSize: '11px',
              color: '#9b9b9b',
              cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>

        <p style={{ fontSize: '10px', color: '#e4e4e1', margin: '0 0 8px 0', textAlign: 'center', letterSpacing: '0.3px' }}>
          built with my little french friend
        </p>

      </div>

      {/* Main Content */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {renderContent()}
      </div>

    </div>
  );
};

export default Dashboard;